/**
 * Complete international example numbers (not just the dial code).
 * Used in help copy so the sample matches the selected country.
 */
const EXAMPLE_PHONE_BY_ISO: Record<string, string> = {
  fr: '+33 6 12 34 56 78',
  be: '+32 470 12 34 56',
  ch: '+41 79 123 45 67',
  lu: '+352 621 123 456',
  de: '+49 151 1234 5678',
  it: '+39 312 345 6789',
  es: '+34 612 34 56 78',
  gb: '+44 7400 123456',
  nl: '+31 6 12345678',
  pt: '+351 912 345 678',
  at: '+43 664 123456',
  ie: '+353 85 012 3456',
  us: '+1 202 555 0100',
  ca: '+1 416 555 0100',
  ma: '+212 661-234567',
  dz: '+213 551 23 45 67',
  tn: '+216 20 123 456',
  au: '+61 412 345 678',
  nz: '+64 21 123 4567',
};

const DEFAULT_EXAMPLE = '+33 6 12 34 56 78';

export function getExampleInternationalPhoneNumber(
  iso2: string | undefined,
  dialCode: string | undefined,
): string {
  if (iso2) {
    const example = EXAMPLE_PHONE_BY_ISO[iso2.toLowerCase()];
    if (example) {
      return example;
    }
  }

  if (dialCode) {
    return `+${dialCode} 12 34 56 78`;
  }

  return DEFAULT_EXAMPLE;
}
